export const groupSubcategoriesByName = (dishes) => dishes.reduce((acc, item) => {
    if (item.subcategory_name === null) return acc;

    const existing = acc.find((group) => group.subcategory_name === item.subcategory_name);

    if (existing) {
        if (!existing.subcategory_ids.includes(item.subcategory_id)) {
            existing.subcategory_ids.push(item.subcategory_id);
        }
        existing.dishes.push({ id: item.id });
    } else {
        acc.push({
            subcategory_name: item.subcategory_name,
            subcategory_ids: [item.subcategory_id],
            dishes: [{ id: item.id }],
        });
    }

    return acc;
}, []);
